import React, { useState, useEffect } from 'react';

import useHttpStatus from '~/commons/hooks/useHttpStatus';

import Context from './Context';

const Provider = ({
  children,
}) => {
  const [competitions, setCompetitions] = useState([]);
  const [, req] = useHttpStatus({
    onSuccess({ data }) {
      setCompetitions(data);
    },
  });

  const find = (compId, qSetId) => {
    const comp = competitions.find((c) => c._id === compId);
    const qs = comp && qSetId && comp.questionSets.find(
      (q) => q._id === qSetId,
    );

    return { competition: comp, questionSet: qs };
  };

  const fetch = () => req({
    url: 'api/quiz/competitions/all',
  });

  useEffect(() => {
    fetch();
  }, []);

  return (
    <Context.Provider value={{
      competitions,
      refresh: fetch,
      find,
    }}>
      {children}
    </Context.Provider>
  );
};

export default Provider;
